import cx from 'classnames';
import { ButtonV2, IButtonV2Props } from 'components/ui';
import { forwardRef } from 'react';
import css from './Button.module.scss';

export type { IButtonV2Props as IButtonProps };

export const Button = forwardRef<HTMLButtonElement, IButtonV2Props>(
  ({ className, ...rest }, ref) => (
    <ButtonV2 className={cx(css.button, className)} ref={ref} {...rest} />
  )
);

Button.displayName = 'Button';
